import { render, staticRenderFns } from "./MyOrdersPatentResearcher.vue?vue&type=template&id=32cf66b3&scoped=true"
import script from "./MyOrdersPatentResearcher.vue?vue&type=script&lang=js"
export * from "./MyOrdersPatentResearcher.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersPatentResearcher.vue?vue&type=style&index=0&id=32cf66b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf66b3",
  null
  
)

export default component.exports